import { render, staticRenderFns } from "./EmbedDashboardSection.vue?vue&type=template&id=675b0130&scoped=true"
import script from "./EmbedDashboardSection.vue?vue&type=script&lang=js"
export * from "./EmbedDashboardSection.vue?vue&type=script&lang=js"
import style0 from "./EmbedDashboardSection.vue?vue&type=style&index=0&id=675b0130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675b0130",
  null
  
)

export default component.exports